module.exports = __webpack_public_path__ + "img/img_sp_produce@3x.e35cf9c1.png";